import { RadioInput, SwitchField } from "common";
import { useFormikContext } from "formik";
import React from "react";
import { QrCodePreference, TicketGenerationStrategy } from "types";
import { GuestManagementFormValues } from "./GuestManagement";
import { ContentLayout } from "@/components/Layout/ContentLayout";

interface Props {
    values: QrCodePreference;
    onChange: (field: keyof QrCodePreference, value: any) => void;
}

export const ExperienceTicketsSection = ({ values, onChange }: Props) => {
    const { values: formikValues } = useFormikContext<GuestManagementFormValues>();

    return (
        <>
            <ContentLayout.Section title="Tickets" description="Set up QR Code tickets for this experience">
                <div className="space-y-2.5">
                    <SwitchField isChecked={values.enabled} onChange={(value: boolean) => onChange("enabled", value)}>
                        Enable QR Code tickets for this experience
                    </SwitchField>
                    {values.enabled ? (
                        <div className="ml-10 flex flex-col space-y-2.5">
                            <RadioInput
                                checked={values.ticketGenerationStrategy === TicketGenerationStrategy.BOOKING}
                                onChange={() => onChange("ticketGenerationStrategy", TicketGenerationStrategy.BOOKING)}
                            >
                                One ticket per group/party
                            </RadioInput>
                            <RadioInput
                                checked={values.ticketGenerationStrategy === TicketGenerationStrategy.GUEST}
                                disabled={!formikValues.requireGuestIdentification}
                                onChange={() => onChange("ticketGenerationStrategy", TicketGenerationStrategy.GUEST)}
                            >
                                One ticket per guest
                            </RadioInput>
                        </div>
                    ) : null}
                </div>
            </ContentLayout.Section>

            <hr className="my-6 border-gray-light" />
        </>
    );
};
